import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { concatMap, mergeMap } from 'rxjs/operators';
import { Actions } from '../../actions';
import { CREATE_RECORD_LABEL_ONBOARDING } from '../actions';
import { push } from 'connected-react-router';

import {
  CreateRecordLabelOnboarding,
  CreateRecordLabelOnboardingError,
  CreateRecordLabelOnboardingSuccess,
  UpdateRecordLabelName,
} from '@webapp/store/record-labels/action-creators';
import * as recordLabels from '@webapp/sdk/record-labels';

export const createRecordLabelOnboardingEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, CreateRecordLabelOnboarding>(
      CREATE_RECORD_LABEL_ONBOARDING
    ),
    mergeMap(async (action) => {
      try {
        const recordLabel = await recordLabels.create();
        return [
          new UpdateRecordLabelName(recordLabel.id, action.recordLabelName),
          new CreateRecordLabelOnboardingSuccess({
            ...recordLabel,
            name: action.recordLabelName,
          }),
          push('/dashboard'),
        ];
      } catch (err) {
        return [new CreateRecordLabelOnboardingError(err.message)];
      }
    }),
    concatMap((actions) => actions)
  );
